"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCertificationColumnFormatter = void 0;
/* eslint-disable react/display-name */
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../../gen-src/Localize");
var DataQualityIconHeaderFormatFactory_1 = require("../../dataGrid/headerFormatters/DataQualityIconHeaderFormatFactory");
var SiteUrlsContext_1 = require("../../urls/SiteUrlsContext");
var Styles_1 = require("../Styles");
var useRenderLabels_1 = require("../hook/useRenderLabels");
function createCertificationColumnFormatter(_a) {
    var getPropsFromRowData = _a.getPropsFromRowData, overrides = _a.overrides;
    return (__assign({ name: 'label-certification', dataKey: '', headerText: '', resizable: false, sortable: false, headerTooltip: Localize_1.Messages.ColumnHeaderCertification(), headerFormatter: DataQualityIconHeaderFormatFactory_1.DataQualityIconHeaderCertificationFormatterFactory, cellFormatter: createCertificationCellFormatter({ getPropsFromRowData: getPropsFromRowData }) }, overrides));
}
exports.createCertificationColumnFormatter = createCertificationColumnFormatter;
function createCertificationCellFormatter(_a) {
    var getPropsFromRowData = _a.getPropsFromRowData;
    return function (cellFormatterProps) {
        var props = getPropsFromRowData(cellFormatterProps.row.data);
        return react_1.default.createElement(CertificationCellFormatter, __assign({}, props));
    };
}
function CertificationCellFormatter(props) {
    var _a;
    var siteUrls = react_1.default.useContext(SiteUrlsContext_1.SiteUrlsContext);
    var certifications = (0, useRenderLabels_1.useRenderLabels)(__assign({ controls: { kind: 'icon', siteUrls: (props.controls && 'siteUrls' in props.controls) ? (_a = props.controls) === null || _a === void 0 ? void 0 : _a.siteUrls : siteUrls } }, props)).certifications;
    return (react_1.default.createElement(Styles_1.IconCellWrapper, null, certifications));
}
//# sourceMappingURL=CertificationColumnFormatter.js.map